import React, { FC, useEffect } from 'react'

import { useForm } from 'react-hook-form'

import { TextArea } from '@style-port/roov-ui-components-react'
import { DecorationTitle } from 'src/components/atoms'

import { yupResolver } from 'src/customYup'
import { useCommonContentPage, useGetCommonContentPages, useToast, useAuthority } from 'src/hooks'
import {
  CommonContentPageEntity,
  CommonContentPageFormEntity,
  CommonContentPageFormEntitySchema,
} from 'src/types'

type Props = {
  commonContent: CommonContentPageEntity
  className?: string
}

export const CommonContentAnnotation: FC<Props> = ({ commonContent, className }) => {
  const { refetch } = useGetCommonContentPages()
  const { toCommonContentPageFormEntity, updateCommonContentPage } = useCommonContentPage()
  const { displayErrorTextToast, displayStandardTextToast } = useToast()
  const { register, watch, setValue } = useForm<CommonContentPageFormEntity>({
    resolver: yupResolver(CommonContentPageFormEntitySchema),
    defaultValues: toCommonContentPageFormEntity(commonContent),
  })
  const { canWriteCommonContent } = useAuthority()

  const handleOnBlur = async () => {
    if (commonContent.annotation === watch('annotation')) {
      return
    }

    // TODO: 共通コンテンツのメイン領域をdisableにする処理を追加する

    try {
      const formEntity = toCommonContentPageFormEntity(commonContent)
      const updatedFormEntity = { ...formEntity, annotation: watch('annotation') }
      await updateCommonContentPage({
        commonContentPageId: commonContent.id,
        formEntity: updatedFormEntity,
      })
      refetch()
      displayStandardTextToast('保存しました')
    } catch {
      displayErrorTextToast('保存に失敗しました')
    }
  }

  useEffect(() => {
    setValue('annotation', commonContent.annotation)
  }, [commonContent.annotation, setValue])

  return (
    <div className={className}>
      <DecorationTitle>注釈・免責文</DecorationTitle>

      <TextArea
        sizeType="s"
        placeholder="アップロードしたコンテンツに関する注意事項、コンテンツ表示義務のある注釈などをご入力ください。&#10;例：記載の内容は2020年◯月◯日時点の情報です。今後変更となる場合もございますのでご了承ください。"
        rows={6}
        {...register('annotation')}
        onBlur={handleOnBlur}
        className="tw-w-[43rem] tw-mt-s2"
        disabled={!canWriteCommonContent}
      />
    </div>
  )
}
